import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ECOPortalIntegrationState = {
  eco_portal_integration: {
    parties: [],
    selectedParties: [],
    documentTree: [],
    selectedDocuments: [],
    generating: false,
    generatedToken: null,
    exportId: null,
    apiLoading: false,
    ecoPortalEnabled: false,
  },
}

export const ECOPortalIntegrationActions = {
  fetchEcoPortalIntegrationParties: async ({ commit }, { legalCaseId }) => {
    commit('setEcoPortalIntegrationApiLoading', true)

    return axiosRequest.get(`/legal_cases/${legalCaseId}/eco/parties`).
      then(({ data }) => {
        commit('setEcoPortalIntegrationParties', data || [])
      }).
      catch(handleError).
      finally(_ => commit('setEcoPortalIntegrationApiLoading', false))
  },

  fetchEcoPortalIntegrationDocumentTree: async ({ commit, getters }, { legalCaseId }) => {
    const selectedParties = getters.ecoPortalIntegrationSelectedParties
    commit('setEcoPortalIntegrationApiLoading', true)

    return axiosRequest.post(`/legal_cases/${legalCaseId}/eco/document_tree`, {
      selected_parties: selectedParties?.map(p => p.id) || [],
    }).
      then(({ data }) => {
        commit('setEcoPortalIntegrationDocumentTree', data || [])
      }).
      catch(handleError).
      finally(_ => commit('setEcoPortalIntegrationApiLoading', false))
  },

  exportEcoPortal: async ({ commit, getters }, { legalCaseId }) => {
    const selectedParties = getters.ecoPortalIntegrationSelectedParties
    const selectedDocuments = getters.ecoPortalIntegrationSelectedDocuments
    const exportId = getters.ecoPortalIntegrationExportId

    commit('setEcoPortalIntegrationApiLoading', true)

    return axiosRequest.post(`/legal_cases/${legalCaseId}/eco/export`, {
      export_id: exportId,
      selected_parties: selectedParties?.map(p => p.id) || [],
      selected_documents: selectedDocuments,
    }).
      then(({ data }) => {
        commit('setEcoPortalIntegrationGeneratedToken', data.data)
        commit('setEcoPortalIntegrationExportId', data.id)
      }).
      catch(handleError).
      finally(_ => {
        commit('setEcoPortalIntegrationApiLoading', false)
      })
  },

  clearEcoPortalIntegrationData: async ({ commit }) => {
    commit('setEcoPortalIntegrationParties', [])
    commit('setEcoPortalIntegrationSelectedParties', [])
    commit('setEcoPortalIntegrationDocumentTree', [])
    commit('setEcoPortalIntegrationSelectedDocuments', [])
    commit('setEcoPortalIntegrationGeneratedToken', null)
    commit('setEcoPortalIntegrationExportId', null)
  },

  checkEcoPortalIntegrationEnabled: async ({ commit }, { legalCaseId }) => {
    return axiosRequest.get(`/legal_cases/${legalCaseId}/eco/enabled`).
      then(({ data }) => commit('setEcoPortalIntegrationEnabled', data.enabled)).
      catch(handleError)
  },
}
export const ECOPortalIntegrationGetters = {
  ecoPortalIntegrationParties: state => state.eco_portal_integration.parties,
  ecoPortalIntegrationSelectedParties: state => state.eco_portal_integration.selectedParties,
  ecoPortalIntegrationDocumentTree: state => state.eco_portal_integration.documentTree,
  ecoPortalIntegrationSelectedDocuments: state => state.eco_portal_integration.selectedDocuments,
  ecoPortalIntegrationGeneratedToken: state => state.eco_portal_integration.generatedToken,
  ecoPortalIntegrationExportId: state => state.eco_portal_integration.exportId,
  ecoPortalIntegrationApiLoading: state => state.eco_portal_integration.apiLoading,
  ecoPortalIntegrationEnabled: (state, _, __, rootGetters) => {
    const isAdmin = rootGetters.currentUserIsAdmin

    return state.eco_portal_integration.ecoPortalEnabled && isAdmin
  },
}

export const ECOPortalIntegrationMutations = {
  setEcoPortalIntegrationParties: (state, data) => (state.eco_portal_integration.parties = data),
  setEcoPortalIntegrationSelectedParties: (state, data) => (state.eco_portal_integration.selectedParties = data),
  setEcoPortalIntegrationDocumentTree: (state, data) => (state.eco_portal_integration.documentTree = data),
  setEcoPortalIntegrationSelectedDocuments: (state, data) => (state.eco_portal_integration.selectedDocuments = data),
  setEcoPortalIntegrationGeneratedToken: (state, data) => (state.eco_portal_integration.generatedToken = data),
  setEcoPortalIntegrationExportId: (state, data) => (state.eco_portal_integration.exportId = data),
  setEcoPortalIntegrationApiLoading: (state, data) => (state.eco_portal_integration.apiLoading = data),
  setEcoPortalIntegrationEnabled: (state, data) => (state.eco_portal_integration.ecoPortalEnabled = data),
}
